import React from 'react';
import { Button } from "semantic-ui-react";

const ExpandButton = (props) => {
    const { active, onClick, content } = props;
    return <Button floated={ props.floated || "right" } size={props.size || "small"} content={content} basic={active} compact={typeof props.compact !== "undefined" ? props.compact : true} icon={props.icon || "expand"} color="black" onClick={onClick}/>
}

export default ExpandButton;